import './i18n';
import './styles/global.css'; // Global styles
import 'flag-icon-css/css/flag-icons.min.css'; 

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./context/AuthContext"; // Auth context

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
<React.StrictMode> <AuthProvider> <App /> </AuthProvider>
</React.StrictMode>
);

// ✅ PWA: Register service worker
if ("serviceWorker" in navigator) {
window.addEventListener("load", () => {
navigator.serviceWorker
.register("/service-worker.js")
.then(() => {
console.log("Service Worker registered successfully");
})
.catch((error) => {
console.error("Service Worker registration failed:", error);
});
});
}
